import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function AccountDisabledPage() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut();
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-newsprint text-ink flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-newsprint-panel border border-rule rounded-sm p-8">
        <h1 className="text-xl font-semibold font-headline text-ink mb-4">Account disabled</h1>
        <p className="text-ink/90 mb-6">
          This user account has been disabled. You cannot access the application. If you believe this is an error, please contact support.
        </p>
        <button
          type="button"
          onClick={handleSignOut}
          className="w-full py-2 px-4 bg-ink text-newsprint rounded-sm font-medium hover:opacity-90"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
